export const ERROR_TYPE = "qamf-stripe-error";
export const GENERIC_ERROR_TYPE = "generic-error";
export const STRIPE_ERROR = "stripe-error";
export const OPERATION_ID = "operation-id";
export const STRIPE_PAYMENT_ERROR = "redirect_status";
export const PAYMENT_FORM_ID = "payment-form";
export const ERRORS_TO_HANDLE = ["processing_error"];
